import React from 'react';

import { Currency } from '@crm-framework/utils';

import { ITotalItemProps } from './types';
import { TotalItemWrapper, TotalItemLabel } from './styles';

export const TotalItem = React.memo<ITotalItemProps>(
  ({ isCurrency, label, value }) => (
    <TotalItemWrapper>
      <TotalItemLabel>{`${label}:`}</TotalItemLabel>
      {isCurrency ? (
        <Currency value={value} />
      ) : (
        new Intl.NumberFormat('en-EN').format(value)
      )}
    </TotalItemWrapper>
  )
);
